import { WobType } from '@/enum/WobType'

export interface IWobBaseConstParam {
  wobType: string
  wobDat: string | null
  wobTrmId: number | null
}

export class WobBase {
  public wobType: WobType
  public wobDat: Date | null
  public wobTrmId: number | null

  constructor({ wobType, wobDat = null, wobTrmId = null }:IWobBaseConstParam = {} as IWobBaseConstParam) {
    this.wobType = wobType as WobType
    this.wobDat = wobDat ? new Date(wobDat) : null
    this.wobTrmId = wobTrmId
  }
}
